var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('apexchart',{attrs:{"width":!_vm.$q.screen.lt.md?'500':'350',"options":_vm.orderChartOptions,"series":_vm.orderChartSeries}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }